<template>
  <ul class="nav nav-pills nav-fill mb-2 mb-sm-3 mb-xl-5">
    <slot />
  </ul>
</template>
